// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DiagramPreview {\n  display: flex;\n  max-height: spacing(15);\n  place-content: center; }\n  .DiagramPreview--scrollable {\n    overflow: scroll; }\n", ""]);
// Exports
module.exports = exports;
